<template>
  <div>
    <div style="text-align: center">
      <h3>Tambah Kontak</h3>
    </div>
    <br />
    <form v-on:submit.prevent="addContact">
      <label>Nama*</label>
      <input type="text" class="form-control" v-model="form.name" autofocus required />
      <br />
      <label>Nomor Whatsapp*</label>
      <input type="text" class="form-control" placeholder="08xxxxxxxx" v-model="form.number" required />
      <br />
      <a v-on:click="addVariable" class="btn btn-success text-white" style="display: inline-flex; margin: 5px">
        Tambah Variabel
      </a>
      <a v-on:click="deleteVariable" class="btn btn-danger text-white" style="display: inline-flex; margin: 5px">
        Hapus Variabel
      </a>
      <div class="form-group mb-20">
        <br>
        <div id="var">
          <div v-for="vars in form.variable" :key="vars.id">
            <label for="">Variabel {{ vars.id }}</label>
            <input class="form-control" type="text" v-model="vars.value" required />
            <br />
          </div>
        </div>
      </div>
      <label>Masukkan Kontak Ke Group</label>
      <multiselect v-model="selectedGroup" placeholder="Cari group" label="name" track-by="id" 
        :options="groupdd" :multiple="false" :allow-empty="true" :show-labels="false"
        @input="updateGroup">
        <template slot="singleLabel" slot-scope="props">
          <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
        </template>
        <template slot="option" slot-scope="props">
          <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
        </template>
      </multiselect>
      <br />
      <label>🏷️ Label Kontak (Opsional)</label>
      <div class="label-select-box">
        <span v-for="l in availableLabels" :key="l.id"
          class="label-chip"
          :style="{ background: selectedLabelIds.includes(l.id) ? l.color : '#e9ecef', color: selectedLabelIds.includes(l.id) ? labelTextColor(l.color) : '#666' }"
          @click="toggleLabel(l.id)">
          <i v-if="selectedLabelIds.includes(l.id)" class="fas fa-check"></i> {{ l.name }}
        </span>
        <span v-if="availableLabels.length === 0" class="text-muted small">
          Belum ada label. Buat dulu di menu <router-link to="/contact-labels">Label Kontak</router-link>.
        </span>
      </div>
      <br />
      <div class="button-group d-flex pt-25">
        <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
          simpan
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  export default {
    props: ['groupdd'],
    components: {
      Multiselect
    },
    data() {
      return {
        form: {
          name: "",
          number: "",
          variable: [],
          group: null
        },
        null_value: null,
        selectedGroup: null,
        availableLabels: [],
        selectedLabelIds: []
      };
    },
    mounted() {
      this.loadLabels()
    },
    methods: {
      toggleModal(param) {
        this.$modal.show(param);
      },
      async loadLabels() {
        try {
          const r = await this.$store.dispatch("contact_labels_list")
          this.availableLabels = r.data.data.labels || []
        } catch (e) { /* silent */ }
      },
      labelTextColor(hex) {
        if (!hex || typeof hex !== 'string') return '#fff';
        const h = hex.replace('#', '').trim();
        if (h.length < 6) return '#fff';
        const r = parseInt(h.substr(0, 2), 16);
        const g = parseInt(h.substr(2, 2), 16);
        const b = parseInt(h.substr(4, 2), 16);
        const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return lum > 0.6 ? '#222' : '#fff';
      },
      toggleLabel(id) {
        const i = this.selectedLabelIds.indexOf(id)
        if (i === -1) this.selectedLabelIds.push(id)
        else this.selectedLabelIds.splice(i, 1)
      },
      addVariable() {
        this.form.variable.push({
          id: this.form.variable.length + 1,
          value: ""
        });
      },
      deleteVariable() {
        this.form.variable.splice(-1)
      },
      updateGroup(option) {
        this.form.group = option ? option.id : null
      },
      async addContact() {
        try {
          let response = await this.$store.dispatch('contact_create', this.form)
          // Set label kontak (kalau dipilih) — pakai id kontak baru dari response
          const newId = response.data && response.data.data && response.data.data.id;
          if (newId && this.selectedLabelIds.length > 0) {
            try {
              await this.$store.dispatch('contact_set_labels', { id: newId, label_ids: this.selectedLabelIds })
            } catch (e) { /* kontak tetap dibuat walau set label gagal */ }
          }
          this.$toast.success(response.data.message);
          this.$root.$emit("toggle_modal", "new_contact")
          this.$root.$emit("refresh_table", true)
        } catch (err) {
          this.$toast.error(err.response.data.message);
        }
      },
    },
  };
</script>

<style scoped>
.label-select-box {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #fafbfc;
    min-height: 44px;
    align-items: center;
}
.label-chip {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    transition: all .15s;
}
.label-chip:hover { opacity: .85; transform: translateY(-1px); }
</style>